<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'

import ToastWrapper from '@satch-ui/primitives/toast/ToastWrapper.vue'
import { onShowAddToCartSidePanelEvent } from '@shared/event/events/cart'
import type { CartLine } from '@shared/shop-api/cart/lines/types'
import CartToast from '@storefront-satch/components/organisms/cart/Toast.vue'

const lineItem = ref<CartLine | undefined>(undefined)

const showAddToCartSidePanel = computed(() => !!lineItem.value)

onMounted(() => {
  onShowAddToCartSidePanelEvent(({ cartLine }) => {
    lineItem.value = cartLine
  })
})

const closeAddToCartSidePanel = () => {
  lineItem.value = undefined
}
</script>

<template>
  <ToastWrapper />

  <CartToast
    :is-open="showAddToCartSidePanel"
    :model="lineItem?.variant.product.attributes.model"
    :style="lineItem?.variant.product.attributes.style"
    :image="lineItem?.variant.product.media?.default.url"
    @close="closeAddToCartSidePanel"
  />
</template>
